import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import PropTypes from "prop-types";
import usePolicies from "../shared/hooks/usePolicies";
import { PRIVACY, TERMS_CONDITIONS } from "./services/policyTypes.enum";
import { ProgressBar } from "../shared/components/progressBar";

export default function Popup({ handleClose, open }) {
  const { policies, isLoading } = usePolicies([PRIVACY, TERMS_CONDITIONS]);

  return (
    <div>
      <Dialog
        open={open}
        maxWidth="lg"
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {isLoading && <ProgressBar />}
            {policies?.map((policy) => (
              <div
                className="ck-content"
                id={policy.policyType.replaceAll(" ", "")}
                key={`${policy.policyTypeId}-${policy.version}`}
              >
                <div dangerouslySetInnerHTML={{ __html: policy.body }} />
              </div>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
Popup.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};
Popup.defaultProps = {
  open: null,
};
